module.exports = __webpack_public_path__ + "static/img/20.5fd0eee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/20.png
// module id = 2r/i
// module chunks = 5